export const TABLE_ROW_PER_PAGE_OPTIONS = [5, 10, 15, 25, 50, 100];
export const DEFAULT_PAGE = 1;
export const DEFAULT_PER_PAGE = 15;
export const DEFAULT_PAGE_INDEX = 0;
